// React
import { useState } from "react";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Custum dialog
import DeleteDialog from "layouts/lessons/quizzes/components/modalDelete";
import ModalEdit from "layouts/lessons/quizzes/components/modalEdit";
import { useDispatch, useSelector } from "react-redux";
import Questions from "../questions";

const columns = [
  { Header: "Titre", accessor: "title", align: "left" },
  { Header: "Resumé", accessor: "resume", align: "left" },
  { Header: "Date de création", accessor: "createdAt", align: "center" },
  { Header: "Dérnier modification", accessor: "updatedAt", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];

function QuizzesTableData({ lessonId, toLesson }) {
  const quizzes = useSelector((state) => state.quiz.quizzes);
  const [currentQuiz, setCurrentQuiz] = useState(null);
  const [dialog, setDialog] = useState(null);
  const dispatchApi = useDispatch();

  const finished = () => {
    setDialog(null);
    setCurrentQuiz(null);
  };

  const rows = quizzes.map((quiz) => ({
    title: (
      <div style={{ maxWidth: 200 }}>
        <MDTypography
          sx={{ cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            dispatchApi({ type: "FETCHED_QUESTION", data: quiz.questions });
            setCurrentQuiz(quiz);
            setDialog("questions");
          }}
          variant="caption"
          color="text"
          fontWeight="medium"
        >
          {quiz.title}
        </MDTypography>
      </div>
    ),
    resume: (
      <div style={{ maxWidth: 350 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {quiz.resume}
        </MDTypography>
      </div>
    ),
    createdAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {quiz.createdAt}
      </MDTypography>
    ),
    updatedAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {quiz.updatedAt}
      </MDTypography>
    ),
    action: (
      <MDBox component="div" sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentQuiz(quiz);
            setDialog("edit");
          }}
        >
          Editer
        </MDTypography>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentQuiz(quiz);
            setDialog("remove");
          }}
        >
          Supprimer
        </MDTypography>
      </MDBox>
    ),
  }));

  return (
    <>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
      {dialog === "edit" && (
        <ModalEdit lessonId={lessonId} quiz={currentQuiz} finished={finished} />
      )}
      {dialog === "remove" && (
        <DeleteDialog lessonId={lessonId} quizId={currentQuiz.id} finished={finished} />
      )}

      {dialog === "questions" && (
        <Questions lessonId={lessonId} quiz={currentQuiz} finished={finished} toLesson={toLesson} />
      )}
    </>
  );
}

QuizzesTableData.propTypes = {
  lessonId: PropTypes.number.isRequired,
  toLesson: PropTypes.func.isRequired,
};

export default QuizzesTableData;
